// import { width } from '@mui/system';
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../Components/Component-css/Header.css";
import css from "./Component-css/Nav.module.css";
import { BsPeople } from 'react-icons/bs';
import BottonMenu from "../uiComponents/BottonMenu";
import { BsWallet, BsGift } from 'react-icons/bs'
import { IoMdNotificationsOutline } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import "../Components/Component-css/Header.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { LanguageContext } from "./LanguageContext";
import { useContext } from "react";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import { FaPlus } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import Swal from "sweetalert2";

const w3_close = () => {
  const width = document.getElementById("mySidebar").offsetWidth;
  document.getElementById("mySidebar").style.left = `-${width}px`;
  document.getElementById("sidebarOverlay").style.display = "none";
};
const w3_open = () => {
  document.getElementById("mySidebar").style.left = "0";
  document.getElementById("sidebarOverlay").style.display = "block";
};

const addsetting = localStorage.getItem("sitSetting");

const addCaseSetting = JSON.parse(addsetting);
const udata = localStorage.getItem("udata");
const profileData = JSON.parse(udata);

const Header = ({ user }) => {
  // console.log(user)

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [isdropdownVisible, setIsdropdownVisible] = useState(false);

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible);
  };

  const history = useHistory();

  let access_token = localStorage.getItem("token");
  access_token = localStorage.getItem("token");

  const logout = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // axios
    //   .post(
    //     baseUrl + `logout`,
    //     {
    //       headers: headers,
    //     },

    //     { headers }
    //   )

    const respone = await apiRequest(`logout`, "POST", null, headers)
    // .then((res) => {
    // setUser(res.data)
    localStorage.removeItem("token");
    window.location.reload();
    history.push("/");
    // })
    // .catch((e) => {
    //   if (e.response.status == 401) {
    //     localStorage.removeItem("token");
    //     localStorage.removeItem("token");
    //   }
    // });
  };

  const [promptInstall, setPromptInstall] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false)


  useEffect(() => {
    const handler = e => {
      e.preventDefault();
      console.log('beforeinstallprompt event was fired');
      setPromptInstall(e);
      setSupportsPWA(true)
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      console.log('No promptInstall event available');
      return;
    }
    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
      setPromptInstall(null);
    });
  };

  // language
  const { changeLanguage } = useContext(LanguageContext);
  const translations = {
    hi: {
      commission: "कमीशन: 5% : रेफरल: सभी खेलों के लिए 3%",
      profile: "मेरी प्रोफाइल",
      play: "खेले",
      wallet: "वॉलेट",
      refer: "रेफरल और कमाएँ",
      history: "इतिहास",
      support: "सहायता",
      // app: "ऐप डाउनलोड",
      kyc: "केवाईसी"
    },
    en: {
      commission: "COMMISSION: 5% : REFERRAL: 3% FOR ALL GAMES",
      profile: "My Profile",
      play: "Play",
      wallet: "My Wallet",
      refer: "Refer and Earn",
      history: "History",
      support: "Support",
      // app: " App ",
      kyc: "KYC",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme 
  const { theme, toggleTheme } = useTheme("light");
  const theme1 = localStorage.getItem('theme')

  const styles = {
    backgroundColor: theme1 === 'light' ? '#43536d' : 'black',
    color: theme1 === 'light' ? '#fff' : '#fff',
    // padding: '20px',
    // margin: '20px',
  };
  const styles1 = {
    backgroundColor: theme1 === 'light' ? '#fff' : '#6c757d',
    color: theme1 === 'light' ? 'black !important' : '#fff !important',
    // padding: '20px',
    // margin: '20px',
  };
  const logo = theme1 === 'light' ? '/khelstar.png' : '/khelstar-white.png';

  const colorChange = () => {
    localStorage.setItem("theme", "#fff")
    toggleTheme('#fff')
  }

  useEffect(() => {
    localStorage.setItem("theme", "light")

  }, [])




  return (
    <>
      <div>
        {/* <div className="header_top_message ">
          <span className="">{translations[language].commission}</span>
        </div> */}
        {access_token ? (
          <React.Fragment>
            <div id="sidebarOverlay" onClick={w3_close}></div>
            <div style={styles}>

              <div
                className="w3-sidebar w3-bar-block"
                id="mySidebar"
                style={{ paddingBottom: "70px" }}
              >
                {/* <div className="header_profile">
                <div>
                  <div>
                    {profileData && profileData?.avatar ? (
                      <img
                        src={baseUrl + `${profileData && profileData?.avatar}`}
                        alt=""
                        className="header_user"
                      />
                    ) : (
                      <img
                        src="/images/avatars/Avatar1.png"
                        alt=""
                        className="header_user"
                      />
                    )}
                  </div>
                  <div>
                    <h5 style={{ marginBottom: "0px" }}>{profileData?.Name}</h5>
                  </div>
                  <div>
                    {profileData && profileData?.Phone ? (
                      <h3 style={{ marginBottom: "0px" }}>
                        {profileData?.Phone}
                      </h3>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div> */}
                <div className="sidebar_name_box">
                  <h6>Khel Star</h6>
                <span className=" back_sidebar" onClick={w3_close}><FaArrowLeft /></span>

                </div>
                <Link
                  to={"/Profile"}
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    {user && user?.avatar ? (
                      <img
                        width="30px"
                        height="30px"
                        src={baseUrl + `${user && user?.avatar}`}
                        alt="profile"
                        style={{ borderRadius: "50px" }}
                      />
                    ) : (
                      <img src="/user.png" alt="profile" />
                    )}
                  </picture>
                  <h3>{translations[language].profile}</h3>
                </Link>

                {
                  profileData?.verified != "verified" ?

                    <Link
                      to={"/Profile"}
                      className="w3-bar-item w3-button sidebar_link"
                      onClick={w3_close}
                    >
                      <picture className="icon">
                        {user && user?.avatar ? (
                          <img
                            width="30px"
                            height="30px"
                            src={baseUrl + `${user && user?.avatar}`}
                            alt="profile"
                            style={{ borderRadius: "50px" }}
                          />
                        ) : (
                          <img src="../images/icons/user.png" alt="profile" />
                        )}
                      </picture>
                      <h3>{translations[language].kyc}</h3>
                    </Link>
                    : ""
                }

                <Link
                  to={"/Homepage/ludoClassicManual"}
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img
                      alt="img"
                      src="../images/icons/play.jpg"
                      style={{ height: "22px" }}
                    />
                  </picture>
                  <h3>{translations[language].play}</h3>
                </Link>
                <Link
                  to={"/wallet"}
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img alt="img" src="../images/icons/wallet.png" />
                  </picture>
                  <h3>{translations[language].wallet}</h3>
                </Link>
                {/* <Link
                to={"/wallet"}
                className="w3-bar-item w3-button sidebar_link"
                onClick={w3_close}
              >
                <picture className="icon">
                <BsPeople className="icons" />
                </picture>
                <h3>{translations[language].wallet}</h3>
              </Link> */}

                {addCaseSetting?.isReferral ? (
                  <>
                    <Link
                      to={"/refer"}
                      className="w3-bar-item w3-button sidebar_link"
                      onClick={w3_close}
                    >
                      <picture className="icon">
                        <img alt="img" src="../images/icons/gift-card.png" />
                      </picture>
                      <h3>{translations[language].refer}</h3>
                    </Link>
                  </>
                ) : (
                  ""
                )}

                <Link
                  to={"/history"}
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img alt="img" src="../images/icons/history.png" />
                  </picture>
                  <h3>{translations[language].history}</h3>
                </Link>

                {/* <Link
                to={"/Notification"}
                className="w3-bar-item w3-button sidebar_link"
                onClick={w3_close}
              >
                <picture className="icon">
                  <img alt="img" src="../images/icons/bells.png" />
                </picture>
                <h3>Notification</h3>
              </Link> */}

                <Link
                  to={"/support"}
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img alt="img" src="../images/icons/customer-support.png" />
                  </picture>
                  <h3>{translations[language].support}</h3>
                </Link>
                {/* 
                {supportsPWA ? <div
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={onClick}
                  disabled={!promptInstall}
                >
                  <picture className="icon">
                    <img alt="img" src="../images/icons/download.png" />
                  </picture>
                  <h3>{translations[language].app}</h3>
                </div> : ""} */}

                {/* {supportsPWA ? <div
                  className="app-download"
                  onClick={onClick}
                  disabled={!promptInstall}
                >
                  <div className="d-flex align-items-center">
                    <picture className="icon  blink">
                      <img alt="img" src="../images/icons/download.png" style={{ color: "red" }} />
                    </picture>
                    <span>App</span>
                  </div>

                </div> : ""} */}

                <div className="w3-bar-item w3-button sidebar_link ">
                  <picture className="icon">
                    <img alt="img" src="../images/icons/translate.png" />
                  </picture>

                  {/* <button class="on"  onClick={() => changeLanguage('en')}>English</button>
	    <button class="off" onClick={() => changeLanguage('hi')}>Hindi</button> */}

                  <div className="toggle-container">
                    <button
                      className={`toggle-button ${language === "en" ? "active" : ""
                        }`}
                      onClick={() => changeLanguage("en")}
                    >
                      English
                    </button>
                    <button
                      className={`toggle-button ${language === "hi" ? "active" : ""
                        }`}
                      onClick={() => changeLanguage("hi")}
                    >
                      Hindi
                    </button>
                  </div>
                </div>
                <div
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={toggleDiv}
                >
                  <picture className="icon">
                    <img alt="img" src="../images/icons/policy.png" />
                  </picture>
                  <h3>{isdropdownVisible ? "All Policy" : "All Policy"}</h3>
                </div>
                {isdropdownVisible && (
                  <ul className="dropdown_link">
                    <li>
                      <Link to="/privacy-policy" onClick={w3_close}>
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/RefundPolicy" onClick={w3_close}>
                        Refund/Cancellation Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/term-condition" onClick={w3_close}>
                        Terms &amp; Condition
                      </Link>
                    </li>
                    <li>
                      <Link to="/tds-policy" onClick={w3_close}>
                        TDS Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/responsible-gaming" onClick={w3_close}>
                        Responsible Gaming
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" onClick={w3_close}>
                        About
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact-us" onClick={w3_close}>
                        Contact
                      </Link>
                    </li>
                  </ul>
                )}

                <div
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon style-2">
                    <img alt="img" src="../images/icons/back.png" />
                  </picture>
                  <h3>Back</h3>
                </div>
              </div>
            </div>


            <div className="w3-teal" style={styles}>
              <div className="w3-container " style={styles}>
                <div className={`${css.headerContainer} `} style={styles}>
                  <button
                    className=" w3-xlarge float-left menu_button "
                    onClick={w3_open}
                    id="hambergar"
                  >
                    <picture className={`${css.sideNavIcon} mr-0`}>
                      <GiHamburgerMenu style={styles} />
                    </picture>
                  </button>
                  <Link to="/">
                    <img
                      src={logo}
                      className="snip-img ml-2"
                      alt="logos"
                      width="65px"
                      height="65px"
                    />
                  </Link>

                  {/* {supportsPWA ? <div
                    className="w3-bar-item w3-button postiton-relative1 sidebar_link blink"
                    onClick={onClick}
                    disabled={!promptInstall}
                  >
                    <picture className="icon p-0">
                      <img alt="img" src="../images/icons/download.png" />
                    </picture>
                    <h3 className="text-white">{translations[language].app} App</h3>
                  </div> : ""} */}

                  <div className="top_menu_bar_main" style={styles}>
                    <nav className={`${css.menu_items}`}>
                      <div className="header_navlink_main mr-0">
                        {/* <input type="checkbox" class="checkbox" id="checkbox" />
                        <label for="checkbox" class="checkbox-label">
                          <i class="fas fa-moon" onClick={() => toggleTheme('dark')}></i>
                          <i class="fas fa-sun" onClick={() => toggleTheme('light')}></i>
                          <span class="ball"></span>
                        </label> */}
                        {/* <button class="dlmbtn" onClick={colorChange}>

                          {
                            theme1 === "light" ? <img src="/moon.png" alt="" width="16px" /> :
                              <img src="/sun.png" alt="" width="18px" />
                          }
                        </button> */}
                      </div>
                      <div className="header_navlink_main ml-0">
                        {/* <h5 style={styles}>Coins</h5> */}
                        <NavLink
                          exact
                          to="/Addcase"
                          className="top_menus_link wallet_balance_btn"
                          activeClassName=""
                          onClick={(e) => {
                            if (user?.verified === "unverified") {
                              e.preventDefault(); // Stop navigation
                              Swal.fire({
                                icon: "warning",
                                title: "Please complete KYC",
                                text: "You need to complete your KYC before proceeding.",
                                confirmButtonText: "OK",
                              });
                            }
                          }}
                        >
                          <FaPlus style={{ width: "16px", marginLeft: '2px' }} />
                          <span>{user && Math.floor(Number(user?.Wallet_balance || 0))}</span>
                        </NavLink>

                      </div>

                      <div className="header_navlink_main">
                        {/* <h5 style={styles}>Earning</h5> */}
                        <NavLink
                          exact
                          to="/redeem/refer"
                          className="top_menus_link wallet_balance_btn ml-1 wallet_btn"
                          activeClassName=""
                        >
                          <FaUsers className=' wallet-dark' onClick={w3_close} />
                          <span>{user && Math.floor(Number(user?.referral_wallet || 0))}</span>
                        </NavLink>
                      </div>

                      {/* <div className="header_navlink_main notificatin-icon">


                        <NavLink
                          exact
                          to=""
                          className=""
                          activeClassName=""
                        >
                          <img src="/images/icons/notification.png" alt="" />

                        </NavLink>
                      </div> */}



                      {/* <NavLink
                        exact
                        to="/Notification"
                        className="top_menus_link notification_btn"
                        activeClassName="active_link"
                      >
                        <IoMdNotificationsOutline className="icons" />
                      </NavLink> */}
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="w3-teal " style={styles}>
            <div className="w3-container ">
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to="/">
                  <picture className={`ml-2 ${css.navLogo} d-flex`}>
                    <img
                      src="/khelstar-white.png"
                      className="snip-img"
                      alt="STARKINGADDA"
                      width="30px"
                    />
                  </picture>
                </Link>

                <div className={`ml-5`}>
                  <Link type="button" className="login-btn" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="bottom_menus_main">
        <BottonMenu w3_close={w3_close} />
      </div>
    </>
  );
};

export default Header;
